export const PHOTO_REPORTS_OMP_TYPE = 'omp';
export const PHOTO_REPORTS_DMP_TYPE = 'dmp';

export const DEFAULT_PHOTO_REPORT_SETTINGS = {
    enabled: false,
    omp: {
        name: 'Фото ОМП До/После',
        photosLabel: 'Фото До',
        additionalPhotosLabel: 'Фото После',
        commentLabel: 'Комментарий к Фото До',
        additionalCommentLabel: 'Комментарий к Фото После',
    },
    dmp: {
        name: 'Фото ДМП',
        photosLabel: 'Фото ДМП',
        additionalPhotosLabel: 'Фото дополнительного оборудования',
        commentLabel: 'Комментарий к фото ДМП (Торцы, Острова, Корзины)',
        additionalCommentLabel: 'Комментарий к фото дополнительного оборудования',
    },
};

export const getPhotoReportTypeSettings = (settings, type) => (
    (settings && settings[type]) || DEFAULT_PHOTO_REPORT_SETTINGS[type] || {}
);

export const getPhotoReportTypeName = (settings, type) => (
    getPhotoReportTypeSettings(settings, type).name || type
);

export const getPhotoReportTypes = (settings) => ([
    {
        id: PHOTO_REPORTS_OMP_TYPE,
        name: getPhotoReportTypeName(settings, PHOTO_REPORTS_OMP_TYPE),
    },
    {
        id: PHOTO_REPORTS_DMP_TYPE,
        name: getPhotoReportTypeName(settings, PHOTO_REPORTS_DMP_TYPE),
    },
]);
